module.exports = __webpack_public_path__ + "static/media/S1-12-Zorbozz-cod12.4bcaddb3.png";